import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const RequireAuth = () => {
  const location = useLocation();

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  const isPrintPage = location.pathname.startsWith("/pdf-");
  const hasLoginData =
    !!localStorage.getItem("authToken") &&
    localStorage.getItem("isAuthenticated") === "true";

  const allowed = token || (isPrintPage && hasLoginData);

  return allowed ? <Outlet /> : <Navigate to="/" replace />;
};

export default RequireAuth;